import React, { useState, useEffect, useRef } from "react";
import { Card } from "../Components/cards/Card";

import RoundedImg from "./../Assets/images/Rounded1.png";
import { AlertModal } from "../Components/ViewModals/Modal";
import { BannerCard } from "../Components/cards/BannerCard";
import { Alert, ButtonToolbar, Spinner } from "react-bootstrap";
import { data } from "../variables/variables";
import axios from "axios";
import moment from "moment/moment";
import { Header } from "../Layouts/Header";
import { Navigate } from "react-router-dom";
import { OrdersBanner } from "../Components/cards/OrdersBanner";
import { Modal } from "react-bootstrap";
import {
  get_all_orders,
  update_orders_status,
  refresh_time,
  get_floors,
  check_in_room,
  room_checkout_detail,
  room_check_out,
} from "./apis";
import { OrderNotification } from "../Components/OrderPopup/OrderNotification";
import { notifyOnNewOrders } from "../Utils/notificationSound";
import { useOrderRealtime } from "../Utils/useOrderRealtime";
import {
  ensureNotificationPermissionAsked,
  showOrderBrowserNotification,
  showOrderBrowserNotificationFromPayload,
} from "../Utils/browserNotifications";
import Floor from "../Floor_Component/Floor";
import Floor_Sidebar from "../Floor_Component/Floor_Sidebar";
// Browser OS notifications only (no in-app SlidingOrderToast).
// import { useReactToPrint } from "react-to-print";

// STYLES FILES
import "./../Assets/css/main.css";
import "./../Assets/css/Card.css";
import "./../Assets/css/utility.css";
// import { set } from "immer/dist/internal";

let my_floors = [];

const Reception = () => {
  const [showModal, setShowModal] = useState(false);
  const [allRooms, setAllRooms] = useState([]);
  const [allOrders, setAllOrders] = useState([]);
  const [order_id, setOrder_id] = useState(0);
  const [st_id, setSt_id] = useState(0);
  const [display_banner, setDisplay_banner] = useState(false);
  const [room_name, setRoom_name] = useState("");
  const [roomsResponse, setRoomsResponse] = useState(false);
  const [redirectLogin, setRedirectLogin] = useState(false);
  const [fetchError, setFetchError] = useState("");
  const [responseApi, setResponseApi] = useState(0);
  const [loading, setLoading] = useState(false);
  const [newOrder, setNewOrder] = useState([]);
  const [checInModel, setCheckInModel] = useState(false);
  const [checkout_Model, setCheckout_Model] = useState(false);
  const [customer_info, setCustomer_info] = useState({
    name: "",
    phone_number: "",
  });
  const [orderMenu, setOrderMenu] = useState([]);
  const [room_id, setRoom_id] = useState("");
  const [error, setError] = useState({
    error_name: "",
    error_phone: "",
  });

  const prepare = 0;
  const [check_Out_Modal, setcheck_Out_Modal] = useState(false);
  const [checkOutInfo, setcheckOutInfo] = useState(false);
  const [check_out_detail, setCheck_out_detail] = useState([]);
  const [session, setSession] = useState({});
  const [customer, setCustomer] = useState("");
  const [checkout_message, setCheckout_Message] = React.useState("");
  const [confirm_disable, setConfirm_Disable] = useState(false);
  const [floors, setFloors] = useState([]);
  const [showRightSide, setShowRightSide] = useState(false);
  const [roomObj, setRoomObj] = useState({});
  const [newOrderPopup, setNewOrderPopup] = useState([]);
  const knownOrderIdsRef = useRef(null);
  const openRoomFromNotificationRef = useRef(() => {});

  // const invoicePrint = useRef();
  // const [module, setModel] = useState(false);

  //SetHeader Value
  const user = JSON.parse(localStorage.getItem("user"));
  const headers = {
    Authorization: "Bearer " + user?.token,
  };

  // const handleprint = useReactToPrint({
  //   content: () => invoicePrint.current,
  // });

  useEffect(() => {
    // If user is already logged in and never answered the prompt, ask once.
    ensureNotificationPermissionAsked();
    getOrders();
    getFloors();
  }, []);

  const getFloors = () => {
    axios
      .get(get_floors, { headers })
      .then((res) => {
        // getAllOrders();
        if (res?.data?.status === 200) {
          setFloors(res?.data?.floors);
          my_floors = res?.data?.floors;
          // my_floors = res?.data?.floors;
          setRoomsResponse(true);
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          setRedirectLogin(true);
        } else {
          setFetchError(data["error"]);
          setResponseApi(1);
          setRoomsResponse(false);
        }
      });
  };

  const getOrders = () => {
    axios
      .get(get_all_orders + "/" + 2, { headers })
      .then((res) => {
        if (res?.data?.status === 200) {
          setAllOrders(res?.data?.orders);
          let newOreders = res?.data?.orders;
          let new_array = [];

          const { newOrders } = notifyOnNewOrders(
            newOreders,
            knownOrderIdsRef
          );
          newOrders.forEach((order) => {
            showOrderBrowserNotification(order, {
              onClick: () => {
                openRoomFromNotificationRef.current(
                  order?.room?.id ?? order?.room_id,
                  order?.room
                );
              },
            });
          });

          newOreders.map((item) => {
            let check = new_array.some((el) => el?.room_id == item?.room_id);

            if (check) {
              let old_order = new_array.filter(
                (ele) => ele.room_id == item.room_id
              );

              old_order = old_order[0];
              new_array = new_array.filter(
                (ele) => ele.room_id != item.room_id
              );
              if (old_order.status_id > item.status_id) {
                // new_array = [...new_array, item];

                new_array.push(item);
              } else if (old_order?.status_id == item.status_id) {
                new_array.push(old_order);
              } else {
                new_array.push(old_order);
                // new_array = [...new_array, old_order];
              }
            } else {
              new_array.push(item);
            }
          });

          setNewOrderPopup(new_array);
          //setNewOrder(uniqueNames);
          let deepCopy = JSON.parse(JSON.stringify(my_floors));
          deepCopy = deepCopy.map((floor) => {
            let update_room = floor?.rooms.map((room) => {
              if (new_array.length > 0) {
                new_array.map((item) => {
                  let check = new_array.some((el) => el?.room_id == room?.id);
                  if (check) {
                    if (item?.room_id === room?.id) {
                      if (item?.status_id === 2) {
                        room = {
                          ...room,
                          ord_status: item?.status_id,
                          blink: true,
                        };
                      } else {
                        room = {
                          ...room,
                          ord_status: item?.status_id,
                          blink: false,
                        };
                      }
                    }
                  } else {
                    room = {
                      ...room,
                      ord_status: 0,
                    };
                  }
                });
              } else {
                room = {
                  ...room,
                  ord_status: 0,
                };
              }
              return room;
            });
            return { ...floor, rooms: update_room };
          });
          my_floors = deepCopy;
          setFloors(my_floors);
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          setRedirectLogin(true);
        }
      });
  };
  const handleRoomObj = (id, roomData = null) => {
    let obj = null;

    if (roomData?.id) {
      obj = roomData;
    } else {
      floors.forEach((floor) => {
        floor?.rooms?.forEach((room) => {
          if (
            room?.id != null &&
            (Number(room.id) === Number(id) || String(room.id) === String(id))
          ) {
            obj = room;
          }
        });
      });
    }

    if (!obj && id) {
      obj = {
        id: Number(id) || id,
        name: `Room#${id}`,
        code: null,
        room_status_id: 1,
      };
    }

    if (obj) {
      setRoomObj(obj);
      setShowRightSide(true);
    }
  };

  openRoomFromNotificationRef.current = handleRoomObj;
  const updateOrder = (id, status_id, roomName) => {
    setRoom_name(roomName);
    setShowModal(true);
    status_id++;
    setOrder_id(id);
    setSt_id(status_id);
    setDisplay_banner(false);
  };

  const handleOrder = async (st) => {
    if (st === 1) {
      setLoading(true);
      await axios
        .post(
          update_orders_status + order_id + "/" + st_id,
          { payload: null },
          { headers }
        )
        .then((res) => {
          if (res.data.status === 200) {
            getOrders();
            setShowModal(false);
            setDisplay_banner(true);
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401 || err?.response?.status === 403) {
            setRedirectLogin(true);
          } else {
            setSt_id(0);
            setDisplay_banner(true);
          }
        });
      setLoading(false);
    } else {
      setShowModal(false);
    }
  };

  // Live push from Reverb + slow fallback poll (refresh_time).
  useOrderRealtime(getOrders, {
    departmentId: 2,
    fallbackMs: Number(refresh_time) || 15000,
    onEvent: (payload) => {
      if (
        payload?.department_id != null &&
        Number(payload.department_id) !== 2
      ) {
        return;
      }
      // Mark known so the follow-up poll does not notify twice.
      if (payload?.order?.id != null && knownOrderIdsRef.current) {
        knownOrderIdsRef.current.add(payload.order.id);
      }
      showOrderBrowserNotificationFromPayload(payload, {
        onClick: () => {
          const room = payload?.order?.room;
          openRoomFromNotificationRef.current(
            room?.id ?? payload?.order?.room_id,
            room
          );
        },
      });
    },
  });

  // checked login and not
  if (!user?.token || redirectLogin) {
    return <Navigate replace to="/login" />;
  }

  const order_buttons = (ele) => {
    if (ele?.status_id === 1) {
      return (
        <button
          className="button text-bold1"
          onClick={() => updateOrder(ele?.id, ele?.status_id, ele?.room?.name)}
        >
          {data["acknowledge"]}
        </button>
      );
    } else if (ele?.status_id === 2) {
      return (
        <button
          className="success_btn text-bold1"
          onClick={() => updateOrder(ele?.id, ele?.status_id, ele?.room?.name)}
        >
          {data["dispatch"]}
        </button>
      );
    } else if (ele?.status_id === 3) {
      return (
        <button
          className="success_btn text-bold1"
          onClick={() => updateOrder(ele?.id, ele?.status_id, ele?.room?.name)}
        >
          {data["deliver"]}
        </button>
      );
    }
  };

  return (
    <div className="wrapper">
      <Header userName="Reception" />
      <div className="wrapper_content">
        <div className="main_container">
          {/* <div className="container_content"> */}
          <div className="row" style={{ width: "100%" }}>
            <div
              className={`${
                showRightSide
                  ? "col-lg-8 col-md-8 col-sm-12"
                  : "col-lg-12 col-md-12 col-sm-12"
              }`}
            >
              {floors.map((floor) => (
                <Floor
                  key={floor?.id}
                  floorName={floor?.floor_name}
                  floor_rooms={floor.rooms}
                  setRoomObj={setRoomObj}
                  setShowRightSide={setShowRightSide}
                  showRightSide={showRightSide}
                  // roomColor={roomColor}
                />
              ))}
            </div>
            {showRightSide && (
              <div className="col-lg-4 col-md-8 col-sm-12 floor_sidebar_design">
                <Floor_Sidebar
                  roomObj={roomObj}
                  setShowRightSide={setShowRightSide}
                  setRoomObj={setRoomObj}
                  showRightSide={showRightSide}
                  floors={floors}
                  setFloors={setFloors}
                  my_floors={my_floors}
                  getFloors={getFloors}
                />
              </div>
            )}
          </div>

          {/* waiting response */}
          {/* {!roomsResponse && responseApi === 0 && floors.length === 0 && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden"></span>
              </Spinner>
            )} */}
          {/* No Room Found */}
          {/* {roomsResponse && floors.length === 0 && (
              <p className="error_text">No Floor Find</p>
            )} */}
          {/* Something wrong in api */}
          {/* {!roomsResponse && responseApi === 1 && floors.length === 0 && (
              <p className="error_text">{fetchError}</p>
            )} */}
          {/* </div> */}

          <OrderNotification
            newOrderPopup={newOrderPopup}
            setShowRightSide={setShowRightSide}
            handleRoomObj={handleRoomObj}
          />
        </div>
      </div>
    </div>
  );
};

export default Reception;
